import {Component, OnInit} from '@angular/core';


@Component({
  selector: 'app-aside',
  templateUrl: './app-aside.component.html'
})
export class AppAsideComponent implements OnInit {

  constructor() { }

  ngOnInit() {

  }
}



// WEBPACK FOOTER //
// ./src/app/components/app-aside/app-aside.component.ts